import React, { useEffect, useRef, useState } from 'react'
import { fullScreenHighOrder } from 'src/utils/fullScreenHighorder'
import PropTypes from 'prop-types'
import useInterval from 'src/utils/customHooks/useInterval'

/**
 * 
 * @returns onEnded={(e) => {
          
        }}
 */
function FullscreenScreen({ screen }) {
  const [actualVideo, setActualVideo] = useState(0)
  const [actualHour, setActualHour] = useState(-1)

  const [videos, setVideos] = useState([])
  const videoPlayerRef = useRef(null)
  useInterval(
    () => {
      const now = new Date()
      let hours = now.getHours()
      if (actualHour !== hours) setActualHour(hours)
    },
    60000,
    true,
  )

  useEffect(() => {
    if (actualHour >= 0 && screen) {
      //setVideos(screen.videosURL)
      let videos = screen.videoByHours[actualHour] ?? []
      videos = videos.filter(video =>{
        return !!video?.src
      })
      setVideos(videos)
    }
    return () => {}
  }, [actualHour, screen])

  useEffect(() => {
    if (videoPlayerRef.current && videos.length > 0) {
      videoPlayerRef.current.pause()
      videoPlayerRef.current.src = videos[actualVideo].src
      videoPlayerRef.current.load()
      videoPlayerRef.current.play()
    }

    return () => {}
  }, [actualVideo, videos])
  /*
    useEffect(() => {
      const handleDetectClick = () => {
        if (videoPlayerRef.current) {
          videoPlayerRef.current.play()
        }
      }
      window.addEventListener('keydown', handleDetectClick)
      return () => {
        window.removeEventListener('keydown', handleDetectClick)
      }
    }, [])
    */
  const handleCarrouselVideo = (e) => {
    if (videos.length > 1) {
      setActualVideo((prev) => {
        let next = prev + 1
        if (next >= videos.length) next = 0
        return next
      })
    } else if (videoPlayerRef.current) {
      videoPlayerRef.current.load()
      videoPlayerRef.current.play()
    }
  }

  const handleEnded = (e) => {
    const savedLogs = localStorage.getItem('videoLogs')
      ? JSON.parse(localStorage.getItem('videoLogs'))
      : []
    let hourArray = [`${actualHour}`, '00']
    if (hourArray[0].length === 1) hourArray[0] = `0${actualHour}`
    const time = hourArray.join(':')
    if (savedLogs[`video_ended/${screen.id}/${videos[actualVideo].id}/${time}`]) {
      savedLogs[`video_ended/${screen.id}/${videos[actualVideo].id}/${time}`].count += 1
    } else {
      savedLogs[`video_ended/${screen.id}/${videos[actualVideo].id}/${time}`] = {
        screen_id: screen.id,
        video_id: videos[actualVideo].id,
        type: 'video_ended',
        time: time,
        count: 1,
        created_at: new Date().toLocaleString(),
      }
    }
    localStorage.setItem('videoLogs', JSON.stringify(savedLogs))
    handleCarrouselVideo()
  }
  return (
    <div className="view-fullscreen">
      <video
        ref={videoPlayerRef}
        width="100%"
        height="100%"
        //src={videos[actualVideo]}
        type="video/mp4"
        autoPlay
        playsInline
        onEnded={handleEnded}
        onError={(e) => {
          console.log('error', e)
          handleCarrouselVideo()
        }}
      >
        Tu navegador no admite el elemento <code>video</code>.
      </video>
    </div>
  )
}

FullscreenScreen.propTypes = {
  screen: PropTypes.object,
}
export default fullScreenHighOrder(FullscreenScreen)
